import { initRequire as a } from "./require-init.js";
async function u(e, i = !1) {
  return await a(), new Promise((o, t) => {
    var r, n;
    (n = (r = i && window.top ? window.top : window).require) == null || n.call(
      r,
      e,
      (...w) => o(w),
      t
    );
  });
}
async function f(e, i = !1) {
  return (await u([e], i))[0];
}
export {
  u as requirejs,
  f as requirejsOne
};
